const Footer = () => {
    return (
        <footer className="mt-40 flex flex-col items-center">
            <div className="container-sm opacity-[0.5] h-[1px] self-stretch rounded-sm bg-gradient13 tablet:px-5"></div>
            <div className="container-sm mt-8 flex items-center justify-between gap-5 self-stretch tablet:px-5 mobile:flex-col mb-8">
                <div className="gap-[22px] flex items-center mobile:flex-col">
                    <img src="/images/logo-footer.svg" alt="logo" className="h-[26px] object-contain" />
                    <p className="size-headingxmd heading ui text-shadow-ts4 !font-switzer !text-white-a700_b2">
                        HARVARDXR 2025 @ All Rights Reserved.
                    </p>
                </div>
                <div className="flex justify-between gap-5 sm:w-full">
                    <a href="https://www.linkedin.com/company/harvardxr/posts/?feedView=all"><img src="/images/linkedin.png" alt="LinkedIn" className="h-[24px] cursor-pointer" /></a>
                    <a href="https://www.instagram.com/harvardxrofficial/"><img src="/images/instagram.png" alt="Instagram" className="h-[24px] cursor-pointer" /></a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;